/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon24Solid = forwardRef('ArrowFigureACircleDownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-16a1 1 0 0 1 1 1v8.039l2.293-2.293a1 1 0 0 1 1.414 1.414l-3.006 3.006c-.94.94-2.463.94-3.402 0L7.293 14.16a1 1 0 1 1 1.414-1.414L11 15.039V7a1 1 0 0 1 1-1Z" })));
});
